import { Button } from "components/common/Button";
import type { TraversalCompleteToastProps } from "./types";

export const TraversalCompleteToast = ({
  data,
  closeToast,
}: TraversalCompleteToastProps) => {
  const handleApprove = () => {
    data.onApprove();
    closeToast();
  };

  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm font-medium text-gray-900">{data.title}</p>
      <p className="text-sm text-gray-600">{data.description}</p>
      <div className="flex justify-end gap-2 mt-1">
        <Button size="sm" onClick={closeToast}>
          {data.cancelLabel}
        </Button>
        <Button size="sm" variant="success" onClick={handleApprove}>
          {data.approveLabel}
        </Button>
      </div>
    </div>
  );
};
